import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_API_URI || ""}/public/graphql`,
});

const PublicApolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: httpLink,
});

export default PublicApolloClient;
